// Localization file, segregated based on game name.
// *** NOTE ***
// Those general info are used across different games
// should always maintained in general object to prevent
// double info.

const my = {
  general: {
    wallet: "Bet Credit",
    menulogout: "HOME",// "Logout",
    goodroad: "Dragon Alert",
    menufavourite: "Favourite",
    favouritegame: "Favourite Game",
    availablegame: "Available Game",
    confirm: "Confirm",
    menusfx: "SFX",
    menuon: "ON",
    menuoff: "OFF",
    menurules: "Rules",
    menuresult: "Result",
    menustatement: "Statement",
    menunotification: "Announcement",
    menuviewhistory: "View History",
    menufullscreen: "Full Screen",
    marketclosed: "Market Closed",
    menutrend: "Trend",
    menusimple: "Simple",
    menunormal: "Normal",

    draw_no: "Draw No.",
    rebet: "Rebet",
    no_more_bet: "No More Bets",
    sum: "SUM",
    next_draw: "NEXT DRAW",
    last_bets_for: "Last bets for ",
    bet_total: "Bet Total",
    no_bets_last_round: "No bets last round.",
    max: "Max",
    payout: "Payout",
    min_to: "Minimum",
    max_to: "Maximum",
    cancel: "Cancel",
    bet: "Place Bet",
    ref: "Ref. No",
    gap: "GAP",

    sum_bs_short: "SUM B/S",
    sum_oe_short: "SUM O/E",
    Big: "Big",
    Small: "Small",
    Even: "Even",
    Odd: "Odd",
    Dice: "Dice",
    Triple: "Triple",
    High: "High",
    Low: "Low",
    Black: "Black",
    Red: "Red",
    Joker: "Joker",

    //for history TabPane
    Result: "Result",
    Sum_Player: "Player Sum",
    Sum_Banker: "Player Sum",
    CARD_HISTORY: "CARD HISTORY",
    STATISTICS: "STATISTICS",
    RED_BLACK: "RED/BLACK",
    HI_LO: "UP/DOWN",
    Player: "Player",
    Tie: "Tie",
    Banker: "Banker",
    PLACE_TICKET: "Bet",
    PLACE_FAIL: "Bet Fail!",
    PLACE_SUCCESS: "Bet Successful!",
    ERROR_MIN_TO: "Sorry, your stake cannot lower than minimum bet!",
    ERROR_MAX_TO: "Sorry, your stake cannot higher than maximum bet!",
    ERROR_MAX_DR: "Sorry, you have exceeded Max Bet Per Draw!",
    ERROR_MAX_BTDR: "Sorry, bet type have exceeded Max Bet Per Draw!",
    ERROR_NMB: "Sorry, no more bets.",
    ERROR_GAME_UA:
      "Betting is unavailable at the moment. Please contact us for details, thank you.",
    ERROR_REBET_DONE: "Sorry, you've already rebet your previous bet(s).",
    ERROR_TO: "Sorry, please key in your stake again!",
    ERROR_XAMOUNT: "Sorry, your available fund is not enough to Bet!",
    ERROR_206: "Win limit hit! Please contact your upline, thank you.",
    ERROR_207: "Loss limit hit! Please contact your upline, thank you.",
    ERROR_208: "Account suspended! Please contact your upline, thank you.",
    ERROR_209: "Account inactive! Please contact your upline, thank you.",
  },
  fantan: {
    o1group: "MY-FAN",
    o2group: "MY-SSH",
    o3group: "MY-KWOK",
    o4group: "MY-NIM",
    o5group: "MY-NGA",
    o6group: "MY-OE",
    o7group: "MY-TIE",

    total: "MY-Total",
    odd: "MY-ODD",
    even: "MY-EVEN",
    fan: "MY-FAN",
    ssh: "MY-SSH",
    kwok: "MY-KWOK",
    nga: "MY-NGA",
    nim: "MY-NIM",
    fan1: "1 MY-Fan",
    fan2: "2 MY-Fan",
    fan3: "3 MY-Fan",
    fan4: "4 MY-Fan",

    o5_trend: "MY-E",
    o6_trend: "MY-O",

    result: "MY-RESULT",
    history: "MY-HISTORY",
    OE: "MY-O/E",
  },

  tai_xiu: {
    dicehistory: "DICE HISTORY",
    o1: "Big",
    o1_trend: "B",
    o2: "Small",
    o2_trend: "S",
    o3: "Any Triple",
    o3_trend: "T",
    o4: "Odd",
    o4_trend: "O",
    o5: "Even",
    o5_trend: "E",
    o11: "Dice 1",
    o12: "2x Dice 1",
    o13: "3x Dice 1",
    o21: "Dice 2",
    o22: "2x Dice 2",
    o23: "3x Dice 2",
    o31: "Dice 3",
    o32: "2x Dice 3",
    o33: "3x Dice 3",
    o41: "Dice 4",
    o42: "2x Dice 4",
    o43: "3x Dice 4",
    o51: "Dice 5",
    o52: "2x Dice 5",
    o53: "3x Dice 5",
    o61: "Dice 6",
    o62: "2x Dice 6",
    o63: "3x Dice 6",

    o104: "4",
    o104_trend: "4",
    o105: "5",
    o105_trend: "5",
    o106: "6",
    o106_trend: "6",
    o107: "7",
    o107_trend: "7",
    o108: "8",
    o108_trend: "8",
    o109: "9",
    o109_trend: "9",
    o110: "10",
    o110_trend: "10",
    o111: "11",
    o111_trend: "11",
    o112: "12",
    o112_trend: "12",
    o113: "13",
    o113_trend: "13",
    o114: "14",
    o114_trend: "14",
    o115: "15",
    o115_trend: "15",
    o116: "16",
    o116_trend: "16",
    o117: "17",
    o117_trend: "17",
    o1group: "Big/Any Triple/Small",
    o2group: "Big/Any Triple/Small",
    o3group: "Big/Any Triple/Small",
    o4group: "Odd/Even",
    o5group: "Odd/Even",
    o11group: "Specific Number",
    o21group: "Specific Number",
    o31group: "Specific Number",
    o41group: "Specific Number",
    o51group: "Specific Number",
    o61group: "Specific Number",
    o104group: "Specific Total",
    o105group: "Specific Total",
    o106group: "Specific Total",
    o107group: "Specific Total",
    o108group: "Specific Total",
    o109group: "Specific Total",
    o110group: "Specific Total",
    o111group: "Specific Total",
    o112group: "Specific Total",
    o113group: "Specific Total",
    o114group: "Specific Total",
    o115group: "Specific Total",
    o116group: "Specific Total",
    o117group: "Specific Total",
    "1_dice": "1 Dices",
    "2_dice": "2 Dices",
    "3_dice": "3 Dices",
  },

  hi_lo: {
    o1: "Up",
    o1_trend: "U",
    o2: "Down",
    o2_trend: "D",
    o3: "Red",
    o3_trend: "R",
    o4: "Black",
    o4_trend: "B",
    o5: "2-9",
    o5_trend: "2-9",
    o6: "JQKA",
    o6_trend: "JQKA",
    o7: "KA",
    o7_trend: "KA",
    o101: "A",
    o101_trend: "A",
    o102: "2",
    o102_trend: "2",
    o103: "3",
    o103_trend: "3",
    o104: "4",
    o104_trend: "4",
    o105: "5",
    o105_trend: "5",
    o106: "6",
    o106_trend: "6",
    o107: "7",
    o107_trend: "7",
    o108: "8",
    o108_trend: "8",
    o109: "9",
    o109_trend: "9",
    o110: "J",
    o110_trend: "J",
    o111: "Q",
    o111_trend: "Q",
    o112: "K",
    o112_trend: "K",
    o113: "Joker",
    o113_trend: "J",

    //for new-bet-lot
    o1group: "Up/Down",
    o2group: "Up/Down",
    o3group: "Red/Black",
    o4group: "Red/Black",
    o5group: "2-9",
    o6group: "JQKA",
    o7group: "KA",
    o101group: "A",
    o102group: "2",
    o103group: "3",
    o104group: "4",
    o105group: "5",
    o106group: "6",
    o107group: "7",
    o108group: "8",
    o109group: "9",
    o110group: "J",
    o111group: "Q",
    o112group: "K",
    o113group: "Joker",
  },

  domino: {
    result: "MAIN",
    main: "MAIN",
    o1: "Player",
    o1_trend: "P",
    o2: "Tie",
    o2_trend: "T",
    o3: "Banker",
    o3_trend: "B",

    // Player
    o4: "Big",
    o4_trend: "B",
    o5: "Small",
    o5_trend: "S",
    o6: "Odd",
    o6_trend: "O",
    o7: "Even",
    o7_trend: "E",

    //Banker
    o8: "Big",
    o8_trend: "B",
    o9: "Small",
    o9_trend: "S",
    o10: "Odd",
    o10_trend: "O",
    o11: "Even",
    o11_trend: "E",

    o12_trend: "/",

    //for new-bet-lot
    o1group: "Player/Tie/Banker",
    o2group: "Player/Tie/Banker",
    o3group: "Player/Tie/Banker",
    o4group: "Player Big/Small",
    o5group: "Player Big/Small",
    o6group: "Player Odd/Even",
    o7group: "Player Odd/Even",
    o8group: "Banker Big/Small",
    o9group: "Banker Big/Small",
    o10group: "Banker Odd/Even",
    o11group: "Banker Odd/Even",
    Joker: "Joker",

    P_BS: "P B/S",
    P_OE: "P O/E",
    B_BS: "B B/S",
    B_OE: "B O/E",

    PLAYER: "PLAYER",
    BANKER: "BANKER",
    PLAYER_WIN: "PLAYER WIN",
    BANKER_WIN: "BANKER WIN",
    TIE: "TIE",

    PLAYER_BIG: "PLAYER BIG",
    PLAYER_SMALL: "PLAYER SMALL",
    PLAYER_ODD: "PLAYER ODD",
    PLAYER_EVEN: "PLAYER EVEN",

    BANKER_BIG: "BANKER BIG",
    BANKER_SMALL: "BANKER SMALL",
    BANKER_ODD: "BANKER ODD",
    BANKER_EVEN: "BANKER EVEN",
  },
  maxracing: {
    o1: "C(my)",
    o1_trend: "C(my)",
    o2: "Big(my)",
    o2_trend: "B(my)",
    o3: "Small(my)",
    o3_trend: "S(my)",
    o4: "Odd(my)",
    o4_trend: "O(my)",
    o5: "Even(my)",
    o5_trend: "E(my)",
    o6: "Big(my)",
    o6_trend: "B(my)",
    o7: "Small(my)",
    o7_trend: "S(my)",
    o8: "Odd(my)",
    o8_trend: "O(my)",
    o9: "Even(my)",
    o9_trend: "E(my)",
    o10: "G1(my)",
    o10_trend: "G1(my)",
    o11: "G2(my)",
    o11_trend: "G2(my)",
    o12: "G3(my)",
    o12_trend: "G3(my)",
    o13: "G4(my)",
    o13_trend: "G5(my)",
    o14: "G5(my)",
    o14_trend: "G5(my)",

    //for new-bet-lot
    o1group: "Player/Tie/Banker",
    o2group: "Player/Tie/Banker",
    o3group: "Player/Tie/Banker",
    o4group: "Player Big/Small",
    o5group: "Player Big/Small",
    o6group: "Player Odd/Even",
    o7group: "Player Odd/Even",
    o8group: "Banker Big/Small",
    o9group: "Banker Big/Small",
    o10group: "Banker Odd/Even",
    o11group: "Banker Odd/Even",

    Champion: "Champion(my)",
    C_BS: "C B/S(my)",
    C_OE: "C O/E(my)",
    S_BS: "S B/S(my)",
    S_OE: "S O/E(my)",
    Group: "Group(my)",
    Place_champ: "Place Champion(my)",
    Place_sum_champ: "Place Sum Champion(my)",
    Runner_up: "Runner-up(my)",
    Race_result: "Race Result(my)",
  },
};

export default my;
